import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/system';
import ModelProvider from './ModelProvider';
import './root.css';
const Providers = ({ options, theme, children }) => (_jsx(ModelProvider, { options: options, children: _jsx(StyledEngineProvider, { injectFirst: false, children: _jsx(ThemeProvider, { theme: theme, children: children }) }) }));
export default Providers;
